import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';

import {
  BackendService,
  InsuranceService,
  BobtailStore,
  DataHelperService,
  UPDATE_STORE
} from './../shared/index';

declare var wNumb;

@Component({
  selector: 'pax-display-quote',
  styles: [require('./display-quote.component.sass')],
  template: require('./display-quote.component.html')
})
export class DisplayQuoteComponent implements OnInit, OnDestroy {
  storeData;
  truckValue;
  truckRate: number = 0;
  trailerValue;
  trailerRate: number = 0;
  towingAndStorageBase: number = 5000;
  towingAndStorage: number = 0;
  stateSLTax: number = 0;
  nonTruckingLiability: number = 0;
  uM: number = 0;
  naicooaMembership: number = 0;
  monthlyRate;

  constructor(
    private _store: Store<any>,
    private _backend: BackendService,
    private _insurance: InsuranceService,
    private _helper: DataHelperService
  ) {}

  ngOnInit() {

    this._backend.getFormData('preliminary')
      .then(preliminary => {
        this._backend.getSetting(preliminary['zip'] || '')
          .then(settings => {
            this._store.dispatch({ type: UPDATE_STORE, payload: {
              settings: settings,
              steps: { preliminary: preliminary } }
            });
          });
      });

    // Promise.all([
    //   this._backend.getSetting(),
    //   this._backend.getFormData('preliminary')
    // ]).then(rawStoreData => {
    //   this._store.dispatch({ type: UPDATE_STORE, payload: {
    //     settings: rawStoreData[0],
    //     steps: { preliminary: rawStoreData[1] } }
    //   });
    // });

    // subscribe to Store
    this.storeData = this._store.select('cvform').subscribe((store: BobtailStore) => {
      if (this._helper.isEmptyObject(store.steps) && this._helper.isEmptyObject(store.settings)) {
        return false;
      }

      // update Truck Value and Rate
      this.truckValue = this._insurance.currencyToNumber(store.steps.preliminary['truckValue']);
      this.truckRate = this._insurance.getTruckRate();

      // update Trailer Value and Rate
      this.trailerValue = this._insurance.currencyToNumber(store.steps.preliminary['trailerValue']);
      this.trailerRate = this._insurance.getTrailerRate();

      // update Towing and Storage
      this.towingAndStorage = store.steps.preliminary ? store.steps.preliminary['towingAndStorage'] || 0 : 0;
      this.towingAndStorageBase = this.towingAndStorage ? 10000 : 5000;

      // calculate Tax
      this.stateSLTax = this._insurance.getStateSLTax();

      // get constants
      // this.nonTruckingLiability = parseInt(store.settings['bobtail.constants.non-trucking.liability'], 10) || 0;
      this.nonTruckingLiability = parseFloat(this._insurance.above60k ?
        store.settings['bobtail.constants.non-trucking.liability.over.60k'] :
        store.settings['bobtail.constants.non-trucking.liability']);

      // this.naicooaMembership = parseInt(store.settings['bobtail.constants.naicooa.membership'], 10) || 0;
      this.naicooaMembership = parseFloat(this._insurance.above60k ?
        store.settings['bobtail.constants.naicooa.membership.over.60k'] :
        store.settings['bobtail.constants.naicooa.membership']);

      this.uM = parseInt(store.settings['bobtail.constants.um'], 10) || 0;

      // calculate Monthly Rate
      this.monthlyRate = this._insurance.getMonthlyRate();
    });
  }

  ngOnDestroy() {
    this.storeData.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./resources/themes/pandax/bobtail/app/display-quote/display-quote.component.ts